import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import * as Profile from "@/components/auth/Profile";
import { useStore } from "@/store";

import type { CurrentUser, UserShort } from "@/api";

export const DirectMessageUserpic = observer(function DirectMessageUserpic({
  user,
}: {
  user: UserShort | CurrentUser;
}) {
  return (
    <Profile.Userpic
      aria-hidden
      name={user.name}
      src={user.avatarUrls?.[64]}
      setColorFrom={user.name}
      className="w-6 h-6 sm:w-6 sm:h-6 text-size-13 shrink-0"
    />
  );
});

/** The user's name, marked as the current user's own for a self chat. */
export function useDirectMessageLabel(user: UserShort | CurrentUser) {
  const t = useTranslations();
  const { auth } = useStore();
  const isSelf = user.uid === auth.currentUser?.uid;
  return isSelf ? t("documentsSidebar.directMessageSelf", { name: user.name }) : user.name;
}
